import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const SectionLabel = ({ index, title, meta, sx = {} }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${theme.palette.divider}`,
        pb: 1.5,
        mb: 3.5,
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: -1,
          left: 0,
          width: 44,
          height: '2px',
          borderRadius: '2px',
          backgroundColor: theme.palette.secondary.main,
          boxShadow: `0 0 8px ${theme.palette.secondary.main}`,
        },
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {index && (
          <Typography
            component="span"
            sx={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '0.74rem',
              fontWeight: 700,
              color: theme.palette.secondary.main,
              letterSpacing: '0.08em',
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(229, 169, 60, 0.12)' : 'rgba(184, 134, 11, 0.1)',
              px: 1,
              py: 0.35,
              borderRadius: '6px',
              border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(229, 169, 60, 0.28)' : 'rgba(184, 134, 11, 0.28)'}`,
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            {index}
          </Typography>
        )}
        <Typography
          component="span"
          sx={{
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontSize: '0.82rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.12em',
            color: theme.palette.text.primary,
          }}
        >
          {title}
        </Typography>
      </Box>

      {meta && (
        <Typography
          component="span"
          sx={{
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: '0.74rem',
            color: theme.palette.text.secondary,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            gap: 0.6,
          }}
        >
          <Box component="span" sx={{ color: theme.palette.secondary.main }}>{'//'}</Box>
          {meta}
        </Typography>
      )}
    </Box>
  );
};

export default SectionLabel;
